"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("underscore");
const core_1 = require("@angular/core");
const admin_service_1 = require("../admin.service");
const Models_1 = require("../Models");
const core_2 = require("@uirouter/core");
const devextreme_angular_1 = require("devextreme-angular");
const i0 = require("@angular/core");
const i1 = require("@uirouter/core");
const i2 = require("../admin.service");
const i3 = require("@angular/forms");
const i4 = require("@angular/common");
const i5 = require("devextreme-angular");
const i6 = require("devextreme-angular/ui/nested");
const _c0 = ["gridContainer"];
function EditOrganisationDetailsComponent_div_32_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1, "This cannot be empty\n                                    ");
    i0.ɵɵelementEnd();
} }
function EditOrganisationDetailsComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "\n                                    ");
    i0.ɵɵtemplate(2, EditOrganisationDetailsComponent_div_32_div_2_Template, 2, 0, "div", 58);
    i0.ɵɵtext(3, "\n                                ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(30);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r1.errors.required);
} }
function EditOrganisationDetailsComponent_div_43_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1, "This cannot be empty\n                                    ");
    i0.ɵɵelementEnd();
} }
function EditOrganisationDetailsComponent_div_43_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtext(1, "Value is not valid\n                                    ");
    i0.ɵɵelementEnd();
} }
function EditOrganisationDetailsComponent_div_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "\n                                    ");
    i0.ɵɵtemplate(2, EditOrganisationDetailsComponent_div_43_div_2_Template, 2, 0, "div", 58);
    i0.ɵɵtext(3, "\n                                    ");
    i0.ɵɵtemplate(4, EditOrganisationDetailsComponent_div_43_div_4_Template, 2, 0, "div", 58);
    i0.ɵɵtext(5, "\n                                ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(41);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r3.errors.required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r3.errors.pattern);
} }
const _c1 = function () { return { readOnly: true }; };
function EditOrganisationDetailsComponent_div_182_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, "\n                                ");
    i0.ɵɵelementStart(2, "div", 64);
    i0.ɵɵtext(3, "\n                                    ");
    i0.ɵɵelementStart(4, "dx-data-grid", 65, 66);
    i0.ɵɵtext(6, "\n                                        ");
    i0.ɵɵelement(7, "dxo-paging", 67);
    i0.ɵɵtext(8, "\n                                        ");
    i0.ɵɵelementStart(9, "dxo-editing", 68);
    i0.ɵɵtext(10, "\n                                        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(11, "\n\n                                        ");
    i0.ɵɵelementStart(12, "dxi-column", 69);
    i0.ɵɵtext(13, "\n                                        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(14, "\n                                        ");
    i0.ɵɵelementStart(15, "dxi-column", 70);
    i0.ɵɵtext(16, "\n                                            ");
    i0.ɵɵelement(17, "dxi-validation-rule", 71);
    i0.ɵɵtext(18, "\n                                            ");
    i0.ɵɵelement(19, "dxi-validation-rule", 72);
    i0.ɵɵtext(20, "\n                                        ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(21, "\n                                    ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(22, "\n                                ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(23, "\n\n                            ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("dataSource", ctx_r9.organisation.facilityRaNumbers)("showBorders", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("enabled", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("allowUpdating", true)("allowAdding", false)("allowDeleting", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("editorOptions", i0.ɵɵpureFunction0(8, _c1));
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("pattern", ctx_r9.raPattern);
} }
function EditOrganisationDetailsComponent_div_182_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵtext(1, "\n                            ");
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtext(3, "\n                                ");
    i0.ɵɵelementStart(4, "div", 61);
    i0.ɵɵtext(5, "\n                                    ");
    i0.ɵɵelementStart(6, "label");
    i0.ɵɵtext(7, "\n                                        ");
    i0.ɵɵelementStart(8, "input", 62);
    i0.ɵɵlistener("change", function EditOrganisationDetailsComponent_div_182_Template_input_change_8_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.onProdaChanged($event); })("ngModelChange", function EditOrganisationDetailsComponent_div_182_Template_input_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.organisation.hasMultipleRANumbers = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9, "\n                                        ");
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11, "Add multiple RA numbers");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, "\n                                    ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(13, "\n                                ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(14, "\n                            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(15, "\n                            ");
    i0.ɵɵtemplate(16, EditOrganisationDetailsComponent_div_182_div_16_Template, 24, 9, "div", 63);
    i0.ɵɵtext(17, "\n                        ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngModel", ctx_r5.organisation.hasMultipleRANumbers);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", ctx_r5.organisation.hasMultipleRANumbers);
} }
if (!/localhost/.test(document.location.host)) {
    core_1.enableProdMode();
}
class EditOrganisationDetailsComponent {
    constructor($state, uiRouter, adminService, notificationService, windowService) {
        this.$state = $state;
        this.uiRouter = uiRouter;
        this.adminService = adminService;
        this.notificationService = notificationService;
        this.windowService = windowService;
        this.raPattern = "^[0-9]{9,11}$";
        this.submit = (form) => {
            // Trigger validation on datagrid for auto-filled values
            this.performDataGridValidation().then(validationResult => {
                // As the auto-filled values do not trigger the datagrid validation unless the cell is entered, we need to manually cater for the rules here.
                let counter = 0;
                var validationExpression = new RegExp(this.raPattern);
                this.organisation.facilityRaNumbers.forEach(frn => {
                    if (validationResult) {
                        if (!frn.facilityRaNumber || !validationExpression.test(frn.facilityRaNumber)) {
                            validationResult = false;
                            this.focusCell(counter);
                        }
                        counter++;
                    }
                });
                if (validationResult && form.valid) {
                    this.assignProdaNumberToFacilities();
                    this.adminService.putOrganisation(this.organisation).then((response) => {
                        this.notificationService.success("Organisation details have been successfully saved.");
                        this.$state.go("organisationDetails", { org: this.organisation });
                    }, () => {
                        this.notificationService.error("Unexpected error while saving organisation details.");
                    });
                }
            });
        };
        this.organisation = this.uiRouter.globals.params.org;
    }
    ngOnInit() {
        if (this.organisation === null) {
            this.organisation = new Models_1.OrganisationDto();
            this.adminService.getOrganisation().then((response) => {
                this.organisation = response;
                //See if we already have multiple RA Numbers in the
                this.organisation.facilityRaNumbers.forEach(frn => {
                    if (frn.facilityRaNumber != this.organisation.prodaRaNumber) {
                        this.organisation.hasMultipleRANumbers = true;
                        return;
                    }
                });
            }, () => {
                this.notificationService.error("Unexpected error while getting the organisation details.");
            });
        }
    }
    assignProdaNumberToFacilities() {
        if (!this.organisation.hasMultipleRANumbers) {
            this.organisation.facilityRaNumbers.forEach(frn => {
                frn.facilityRaNumber = this.organisation.prodaRaNumber;
            });
        }
    }
    onProdaChanged(event) {
        this.assignProdaNumberToFacilities();
    }
    focusCell(rowNumber) {
        this.dataGrid.instance.editCell(rowNumber, 1);
    }
    performDataGridValidation() {
        if (this.organisation.hasMultipleRANumbers) {
            var controller = this.dataGrid.instance.getController("validating");
            return controller.validate(true);
        }
        else {
            return Promise.resolve(true);
        }
    }
    cancel(isFormPristine) {
        if (isFormPristine !== true) {
            //if there are any unsaved changes, show the warning
            if (!this.windowService.confirm("Do you want to leave this page? Changes you made may not be saved."))
                return;
        }
        this.$state.go("organisationDetails");
    }
}
exports.EditOrganisationDetailsComponent = EditOrganisationDetailsComponent;
EditOrganisationDetailsComponent.ɵfac = function EditOrganisationDetailsComponent_Factory(t) { return new (t || EditOrganisationDetailsComponent)(i0.ɵɵdirectiveInject(i1.StateService), i0.ɵɵdirectiveInject(i1.UIRouter), i0.ɵɵdirectiveInject(i2.AdminService), i0.ɵɵdirectiveInject('notification.service'), i0.ɵɵdirectiveInject('$window')); };
EditOrganisationDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EditOrganisationDetailsComponent, selectors: [["edit-organisation-details"]], viewQuery: function EditOrganisationDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataGrid = _t.first);
    } }, decls: 204, vars: 11, consts: [["nav-publisher", "admin", 1, "clinical-integration"], [1, "col-xs-12"], [1, "col-xs-8"], [3, "ngSubmit"], ["editOrganisationForm", "ngForm"], [1, "row"], [1, "col-xs-10"], [1, "page-header"], [1, "panel", "panel-default"], [1, "panel-body"], [1, "row", "margin-top-20"], [1, "col-xs-4", "col-xs-offset-1", "margin-top-5", "form-group"], ["for", "name", 1, "control-label"], ["id", "name", "name", "name", "type", "text", "maxlength", "255", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["name", "ngModel"], [4, "ngIf"], ["for", "prodaRaNumber", 1, "control-label"], ["id", "prodaRaNumber", "name", "prodaRaNumber", "type", "text", "required", "", "pattern", "^[0-9]{9,11}$", "maxlength", "10", 1, "form-control", 3, "ngModel", "ngModelChange", "change"], ["prodaRaNumber", "ngModel"], [1, "view-note", "margin-top-5"], [1, "row", "col-xs-4", "col-xs-offset-1"], [1, "sub-header"], [1, "row", "space-below"], [1, "margin-top-5"], ["for", "street1", 1, "control-label"], ["id", "street1", "name", "street1", "type", "text", "maxlength", "50", 1, "form-control", 3, "ngModel", "ngModelChange"], ["ng-if", "editOrganisationForm.$submitted || editOrganisationForm.street1.$touched", "ng-messages", "editOrganisationForm.street1.$error", "role", "alert"], ["ng-messages-include", "validationMessages"], ["for", "street2", 1, "control-label"], ["id", "street2", "name", "street2", "type", "text", "maxlength", "50", 1, "form-control", 3, "ngModel", "ngModelChange"], ["ng-if", "editOrganisationForm.$submitted || editOrganisationForm.street2.$touched", "ng-messages", "editOrganisationForm.street2.$error", "role", "alert"], ["for", "suburb", 1, "control-label"], ["id", "suburb", "name", "suburb", "type", "text", "maxlength", "50", 1, "form-control", 3, "ngModel", "ngModelChange"], ["ng-if", "editOrganisationForm.$submitted || editOrganisationForm.suburb.$touched", "ng-messages", "editOrganisationForm.suburb.$error", "role", "alert"], ["for", "state", 1, "control-label"], ["id", "state", "name", "state", 1, "form-control", 3, "ngModel", "ngModelChange"], ["value", ""], ["value", "AustralianCapitalTerritory"], ["value", "NewSouthWales"], ["value", "NorthernTerritory"], ["value", "Queensland"], ["value", "SouthAustralia"], ["value", "Tasmania"], ["value", "Victoria"], ["value", "WesternAustralia"], ["ng-if", "editOrganisationForm.$submitted || editOrganisationForm.state.$touched", "ng-messages", "editOrganisationForm.state.$error", "role", "alert"], ["for", "postCode", 1, "control-label"], ["id", "postCode", "name", "postCode", "type", "text", "pattern", "[0-9]*", "maxlength", "4", 1, "form-control", 3, "ngModel", "ngModelChange"], ["ng-if", "editOrganisationForm.$submitted || editOrganisationForm.postCode.$touched", "ng-messages", "editOrganisationForm.postCode.$error", "role", "alert"], ["for", "country", 1, "control-label"], ["id", "country", "name", "country", "type", "text", "maxlength", "50", 1, "form-control", 3, "ngModel", "ngModelChange"], ["ng-if", "editOrganisationForm.$submitted || editOrganisationForm.country.$touched", "ng-messages", "editOrganisationForm.country.$error", "role", "alert"], ["class", "row col-xs-6 col-xs-offset-1", 4, "ngIf"], [1, "panel-footer"], [1, "pull-left"], [1, "btn", "btn-warning", "btn-lg", "btn-inline-block-lg", 3, "click"], [1, "pull-right"], ["type", "submit", 1, "btn", "btn-primary", "btn-lg", "btn-inline-block-lg"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"], [1, "row", "col-xs-6", "col-xs-offset-1"], [1, "form-group", "has-feedback", "checkbox", "checkbox-large", "margin-top-5"], ["name", "hasMultipleRANumbers", "type", "checkbox", 3, "ngModel", "change", "ngModelChange"], ["class", "row", 4, "ngIf"], [1, "report-table"], ["id", "gridContainer", 3, "dataSource", "showBorders"], ["gridContainer", ""], [3, "enabled"], ["mode", "cell", 3, "allowUpdating", "allowAdding", "allowDeleting"], ["dataField", "facilityName", "caption", "FACILITY", 3, "editorOptions"], ["dataField", "facilityRaNumber", "caption", "RA NUMBER"], ["type", "required"], ["type", "pattern", "message", "Value is not valid", 3, "pattern"]], template: function EditOrganisationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r14 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1, "\n    ");
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtext(3, "\n        ");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtext(5, "\n            ");
        i0.ɵɵelementStart(6, "form", 3, 4);
        i0.ɵɵlistener("ngSubmit", function EditOrganisationDetailsComponent_Template_form_ngSubmit_6_listener() { i0.ɵɵrestoreView(_r14); const _r0 = i0.ɵɵreference(7); return ctx.submit(_r0.form); });
        i0.ɵɵtext(8, "\n                ");
        i0.ɵɵelementStart(9, "div", 5);
        i0.ɵɵtext(10, "\n                    ");
        i0.ɵɵelementStart(11, "div", 6);
        i0.ɵɵtext(12, "\n                        ");
        i0.ɵɵelementStart(13, "h1", 7);
        i0.ɵɵtext(14, "Organisation details");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(15, "\n                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(16, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(17, "\n\n                ");
        i0.ɵɵelementStart(18, "div", 8);
        i0.ɵɵtext(19, "\n                    ");
        i0.ɵɵelementStart(20, "div", 9);
        i0.ɵɵtext(21, "\n                        ");
        i0.ɵɵelementStart(22, "div", 10);
        i0.ɵɵtext(23, "\n\n                            ");
        i0.ɵɵelementStart(24, "div", 11);
        i0.ɵɵtext(25, "\n                                ");
        i0.ɵɵelementStart(26, "label", 12);
        i0.ɵɵtext(27, "Organisation name");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(28, "\n\n                                ");
        i0.ɵɵelementStart(29, "input", 13, 14);
        i0.ɵɵlistener("ngModelChange", function EditOrganisationDetailsComponent_Template_input_ngModelChange_29_listener($event) { return ctx.organisation.name = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(31, "\n                                ");
        i0.ɵɵtemplate(32, EditOrganisationDetailsComponent_div_32_Template, 4, 1, "div", 15);
        i0.ɵɵtext(33, "\n\n                            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(34, "\n\n                            ");
        i0.ɵɵelementStart(35, "div", 11);
        i0.ɵɵtext(36, "\n                                ");
        i0.ɵɵelementStart(37, "label", 16);
        i0.ɵɵtext(38, "Organisation RA number");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(39, "\n                                ");
        i0.ɵɵelementStart(40, "input", 17, 18);
        i0.ɵɵlistener("ngModelChange", function EditOrganisationDetailsComponent_Template_input_ngModelChange_40_listener($event) { return ctx.organisation.prodaRaNumber = $event; })("change", function EditOrganisationDetailsComponent_Template_input_change_40_listener($event) { return ctx.onProdaChanged($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(42, "\n                                ");
        i0.ɵɵtemplate(43, EditOrganisationDetailsComponent_div_43_Template, 6, 2, "div", 15);
        i0.ɵɵtext(44, "\n                                ");
        i0.ɵɵelementStart(45, "div", 19);
        i0.ɵɵtext(46, "New facilities get this number by default.");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(47, "\n                            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(48, "\n\n                        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(49, "\n                        ");
        i0.ɵɵelementStart(50, "div", 20);
        i0.ɵɵtext(51, "\n                            ");
        i0.ɵɵelementStart(52, "div", 5);
        i0.ɵɵtext(53, "\n                                ");
        i0.ɵɵelementStart(54, "h2", 21);
        i0.ɵɵtext(55, "Address (optional)");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(56, "\n                            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(57, "\n                            ");
        i0.ɵɵelementStart(58, "div", 22);
        i0.ɵɵtext(59, "\n                                ");
        i0.ɵɵelementStart(60, "div", 23);
        i0.ɵɵtext(61, "\n                                    ");
        i0.ɵɵelementStart(62, "label", 24);
        i0.ɵɵtext(63, "Street line 1");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(64, "\n                                    ");
        i0.ɵɵelementStart(65, "input", 25);
        i0.ɵɵlistener("ngModelChange", function EditOrganisationDetailsComponent_Template_input_ngModelChange_65_listener($event) { return ctx.organisation.street1 = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(66, "\n                                    ");
        i0.ɵɵelementStart(67, "div", 26);
        i0.ɵɵtext(68, "\n                                        ");
        i0.ɵɵelement(69, "div", 27);
        i0.ɵɵtext(70, "\n                                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(71, "\n                                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(72, "\n                            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(73, "\n\n                            ");
        i0.ɵɵelementStart(74, "div", 22);
        i0.ɵɵtext(75, "\n                                ");
        i0.ɵɵelementStart(76, "div", 23);
        i0.ɵɵtext(77, "\n                                    ");
        i0.ɵɵelementStart(78, "label", 28);
        i0.ɵɵtext(79, "Street 2");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(80, "\n                                    ");
        i0.ɵɵelementStart(81, "input", 29);
        i0.ɵɵlistener("ngModelChange", function EditOrganisationDetailsComponent_Template_input_ngModelChange_81_listener($event) { return ctx.organisation.street2 = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(82, "\n                                    ");
        i0.ɵɵelementStart(83, "div", 30);
        i0.ɵɵtext(84, "\n                                        ");
        i0.ɵɵelement(85, "div", 27);
        i0.ɵɵtext(86, "\n                                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(87, "\n                                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(88, "\n                            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(89, "\n\n                            ");
        i0.ɵɵelementStart(90, "div", 22);
        i0.ɵɵtext(91, "\n                                ");
        i0.ɵɵelementStart(92, "div", 23);
        i0.ɵɵtext(93, "\n                                    ");
        i0.ɵɵelementStart(94, "label", 31);
        i0.ɵɵtext(95, "Suburb");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(96, "\n                                    ");
        i0.ɵɵelementStart(97, "input", 32);
        i0.ɵɵlistener("ngModelChange", function EditOrganisationDetailsComponent_Template_input_ngModelChange_97_listener($event) { return ctx.organisation.suburb = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(98, "\n                                    ");
        i0.ɵɵelementStart(99, "div", 33);
        i0.ɵɵtext(100, "\n                                        ");
        i0.ɵɵelement(101, "div", 27);
        i0.ɵɵtext(102, "\n                                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(103, "\n                                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(104, "\n                            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(105, "\n\n                            ");
        i0.ɵɵelementStart(106, "div", 22);
        i0.ɵɵtext(107, "\n                                ");
        i0.ɵɵelementStart(108, "div", 23);
        i0.ɵɵtext(109, "\n                                    ");
        i0.ɵɵelementStart(110, "label", 34);
        i0.ɵɵtext(111, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(112, "\n                                    ");
        i0.ɵɵelementStart(113, "select", 35);
        i0.ɵɵlistener("ngModelChange", function EditOrganisationDetailsComponent_Template_select_ngModelChange_113_listener($event) { return ctx.organisation.state = $event; });
        i0.ɵɵtext(114, "\n                                        ");
        i0.ɵɵelement(115, "option", 36);
        i0.ɵɵtext(116, "\n                                        ");
        i0.ɵɵelementStart(117, "option", 37);
        i0.ɵɵtext(118, "ACT");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(119, "\n                                        ");
        i0.ɵɵelementStart(120, "option", 38);
        i0.ɵɵtext(121, "New South Wales");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(122, "\n                                        ");
        i0.ɵɵelementStart(123, "option", 39);
        i0.ɵɵtext(124, "Northern Territory");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(125, "\n                                        ");
        i0.ɵɵelementStart(126, "option", 40);
        i0.ɵɵtext(127, "Queensland");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(128, "\n                                        ");
        i0.ɵɵelementStart(129, "option", 41);
        i0.ɵɵtext(130, "South Australia");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(131, "\n                                        ");
        i0.ɵɵelementStart(132, "option", 42);
        i0.ɵɵtext(133, "Tasmania");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(134, "\n                                        ");
        i0.ɵɵelementStart(135, "option", 43);
        i0.ɵɵtext(136, "Victoria");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(137, "\n                                        ");
        i0.ɵɵelementStart(138, "option", 44);
        i0.ɵɵtext(139, "Western Australia");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(140, "\n                                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(141, "\n                                    ");
        i0.ɵɵelementStart(142, "div", 45);
        i0.ɵɵtext(143, "\n                                        ");
        i0.ɵɵelement(144, "div", 27);
        i0.ɵɵtext(145, "\n                                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(146, "\n                                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(147, "\n                            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(148, "\n\n                            ");
        i0.ɵɵelementStart(149, "div", 22);
        i0.ɵɵtext(150, "\n                                ");
        i0.ɵɵelementStart(151, "div", 23);
        i0.ɵɵtext(152, "\n                                    ");
        i0.ɵɵelementStart(153, "label", 46);
        i0.ɵɵtext(154, "Postcode");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(155, "\n                                    ");
        i0.ɵɵelementStart(156, "input", 47);
        i0.ɵɵlistener("ngModelChange", function EditOrganisationDetailsComponent_Template_input_ngModelChange_156_listener($event) { return ctx.organisation.postCode = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(157, "\n                                    ");
        i0.ɵɵelementStart(158, "div", 48);
        i0.ɵɵtext(159, "\n                                        ");
        i0.ɵɵelement(160, "div", 27);
        i0.ɵɵtext(161, "\n                                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(162, "\n                                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(163, "\n                            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(164, "\n\n                            ");
        i0.ɵɵelementStart(165, "div", 22);
        i0.ɵɵtext(166, "\n                                ");
        i0.ɵɵelementStart(167, "div", 23);
        i0.ɵɵtext(168, "\n                                    ");
        i0.ɵɵelementStart(169, "label", 49);
        i0.ɵɵtext(170, "Country");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(171, "\n                                    ");
        i0.ɵɵelementStart(172, "input", 50);
        i0.ɵɵlistener("ngModelChange", function EditOrganisationDetailsComponent_Template_input_ngModelChange_172_listener($event) { return ctx.organisation.country = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(173, "\n                                    ");
        i0.ɵɵelementStart(174, "div", 51);
        i0.ɵɵtext(175, "\n                                        ");
        i0.ɵɵelement(176, "div", 27);
        i0.ɵɵtext(177, "\n                                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(178, "\n                                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(179, "\n                            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(180, "\n                        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(181, "\n\n                        ");
        i0.ɵɵtemplate(182, EditOrganisationDetailsComponent_div_182_Template, 18, 2, "div", 52);
        i0.ɵɵtext(183, "\n                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(184, "\n                    ");
        i0.ɵɵelementStart(185, "div", 53);
        i0.ɵɵtext(186, "\n                        ");
        i0.ɵɵelementStart(187, "div", 54);
        i0.ɵɵtext(188, "\n                            ");
        i0.ɵɵelementStart(189, "a", 55);
        i0.ɵɵlistener("click", function EditOrganisationDetailsComponent_Template_a_click_189_listener() { i0.ɵɵrestoreView(_r14); const _r0 = i0.ɵɵreference(7); return ctx.cancel(_r0.form.pristine); });
        i0.ɵɵtext(190, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(191, "\n                        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(192, "\n                        ");
        i0.ɵɵelementStart(193, "div", 56);
        i0.ɵɵtext(194, "\n                            ");
        i0.ɵɵelementStart(195, "button", 57);
        i0.ɵɵtext(196, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(197, "\n                        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(198, "\n                    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(199, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(200, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(201, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(202, "\n    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(203, "\n");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(7);
        const _r1 = i0.ɵɵreference(30);
        const _r3 = i0.ɵɵreference(41);
        i0.ɵɵadvance(29);
        i0.ɵɵproperty("ngModel", ctx.organisation.name);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", _r1.errors && (_r0.submitted || _r1.touched));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngModel", ctx.organisation.prodaRaNumber);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", _r3.errors && (_r0.submitted || _r3.touched));
        i0.ɵɵadvance(22);
        i0.ɵɵproperty("ngModel", ctx.organisation.street1);
        i0.ɵɵadvance(16);
        i0.ɵɵproperty("ngModel", ctx.organisation.street2);
        i0.ɵɵadvance(16);
        i0.ɵɵproperty("ngModel", ctx.organisation.suburb);
        i0.ɵɵadvance(16);
        i0.ɵɵproperty("ngModel", ctx.organisation.state);
        i0.ɵɵadvance(43);
        i0.ɵɵproperty("ngModel", ctx.organisation.postCode);
        i0.ɵɵadvance(16);
        i0.ɵɵproperty("ngModel", ctx.organisation.country);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", (ctx.organisation == null ? null : ctx.organisation.facilityRaNumbers == null ? null : ctx.organisation.facilityRaNumbers.length) > 1);
    } }, directives: [i3.ɵangular_packages_forms_forms_y, i3.NgControlStatusGroup, i3.NgForm, i3.DefaultValueAccessor, i3.MaxLengthValidator, i3.RequiredValidator, i3.NgControlStatus, i3.NgModel, i4.NgIf, i3.PatternValidator, i3.SelectControlValueAccessor, i3.NgSelectOption, i3.ɵangular_packages_forms_forms_x, i3.CheckboxControlValueAccessor, i5.DxDataGridComponent, i6.DxoPagingComponent, i6.DxoEditingComponent, i6.DxiColumnComponent, i6.DxiValidationRuleComponent], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(EditOrganisationDetailsComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'edit-organisation-details',
                templateUrl: './edit-organisation-details.component.html',
                preserveWhitespaces: true
            }]
    }], function () { return [{ type: i1.StateService }, { type: i1.UIRouter }, { type: i2.AdminService }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['notification.service']
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['$window']
            }] }]; }, { dataGrid: [{
            type: core_1.ViewChild,
            args: ['gridContainer']
        }] }); })();
